import { InputHTMLAttributes } from "react";
import Text from "./Text";
import Input from "./Input";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  labelWidth?: string | number;
  inputClassName?: string;
}

export default function InputField(props: Props) {
  const { className, inputClassName, label, labelWidth, ...inputProps } = props;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Text text={label} width={labelWidth} size="medium" weight="medium" />
      <Input className={inputClassName} {...inputProps} />
    </div>
  );
}
